'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],
    _percentOff: null,
    _amountOff: null,
    _couponCode: null,

    applyCoupon: function applyCoupon(percentOff, amountOff, couponCode) {
        this._percentOff = percentOff;
        this._amountOff = amountOff;
        this._couponCode = couponCode;

        this.triggerCouponChange();
    },
    removeCoupon: function removeCoupon() {
        this._percentOff = null;
        this._amountOff = null;
        this._couponCode = null;

        this.triggerCouponChange();
    },
    triggerCouponChange: function triggerCouponChange() {
        var couponObj = {
            percentOff: this._percentOff,
            amountOff: this._amountOff,
            couponCode: this._couponCode
        };

        this.trigger('change', couponObj);
    }
});
exports.default = CouponStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/CouponStore.jsx
// module id = 415
// module chunks = 0